import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent8: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Quantify value proposition</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Quantify value proposition
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step, you will determine how the benefits of your product turn into value that the customer gets out of your product. You will calculate quantitative metrics (in most cases) to show this value to the customer.

The Quantified Value Proposition gives you a concrete understanding of the measurable benefits your product will bring to your target customers— in the dimension that matters most to them and will most motivate them to action. The Quantified Value Proposition is framed by the top priority of the Persona. This is critically important to know what variable you will be measuring and ensure that it aligns with your targeted customer’s interests and not your interests.

Once you have identified this, you then need to understand and map the “as-is” state in a way familiar to the customer, using the full life cycle use case in this dimension. Next, you map out the “possible” state that will result from using your product, clearly indicating where the customer receives value based on the Persona’s top priority.

A visual, one-page diagram is best, because the customer can easily see the Quantified Value Proposition and can show it to others for validation. When done well, this will be of immense value to you throughout the process of launching your business, so extra effort spent to get this optimized is well worth it. Try wherever possible to use the same language as the customer and also get your work reviewed and verified by the target customer.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Define the quantified value proposition
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  Create a value proposition focused on the criteria you identified as your Persona’s top priority. If their top priority is time to market for producing goods, and your product’s value is that it will lower the cost of production, your value proposition—Our product saves $ XX per month—will not persuade your target customer to buy your product. Your value proposition is not aligned with their highest priority, so purchasing your product will not be a high priority for the target customer, and will quickly be forgotten. If your product also lowers the time to market, you should focus your Quantified Value Proposition on that benefit and do not talk about the cost savings. Keep it simple and focused.

Verify that the value proposition is aligned with the highest priority in the Persona profile.
Evaluate the “as-is” state that does not involve use of your product in terms of benefits/costs.
Evaluate the “possible” state that you are confident will exist when the customer is using your solution, also in terms of benefits/costs.
Set up a simple comparison between the two above—the difference between them is the Quantified Value Proposition.
Describe the Quantified Value Proposition in only one sentence.
Create a supporting diagram showing the “as-is” state as compared to the “possible” state that visually illustrates the value your product has to the customer.
Make sure you use the words of the customer in your diagram so they can understand that it is customized to them— or at least to their industry.
Make sure you make the numbers in the “possible” state ones that you are highly confident your product can attain.
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent8 };
